import { handleResponse, handleError, createApiClient, getHeader } from '@/helpers/api'

const apiBackofficeClient = createApiClient(`${window.config.VUE_APP_API_BASE_URL}/Backoffice`)

// EXPORTS
export const backofficeService = {
  roleView,
  userView,
  organizationView,
  createRole,
  deleteRole,
  addPermissionToRole,
  removePermissionFromRole,
  addRoleToUser,
  removeRoleFromUser,
  setOrganizationRole,
  changeUniqueRoleFromUser
}

// API CALLS
async function roleView() {
  return apiBackofficeClient
    .get('/RoleView')
    .then(handleResponse)
    .catch(handleError)
}

async function userView(payload) {
  return apiBackofficeClient
    .get(`/UserView?${payload.query}`)
    .then(handleResponse)
    .catch(handleError)
}

async function organizationView(payload) {
  return apiBackofficeClient
    .get(`/OrganizationView?${payload.query}`)
    .then(handleResponse)
    .catch(handleError)
}

async function createRole(payload) {
  return apiBackofficeClient
    .post('/CreateRole', payload)
    .then(handleResponse)
    .catch(handleError)
}

async function deleteRole(roleName) {
  return apiBackofficeClient
    .put('/DeleteRole',
      JSON.stringify(roleName),
      getHeader())
    .then(handleResponse)
    .catch(handleError)
}

async function addPermissionToRole(payload) {
  return apiBackofficeClient
    .post('/addPermissionToRole', payload)
    .then(handleResponse)
    .catch(handleError)
}

async function removePermissionFromRole(payload) {
  return apiBackofficeClient
    .post('/removePermissionFromRole', payload)
    .then(handleResponse)
    .catch(handleError)
}

async function addRoleToUser(payload) {
  return apiBackofficeClient
    .post('/addRoleToUser', payload)
    .then(handleResponse)
    .catch(handleError)
}

async function changeUniqueRoleFromUser(payload) {
  return apiBackofficeClient
    .post('/ChangeUniqueRoleFromUser', payload)
    .then(handleResponse)
    .catch(handleError)
}


async function removeRoleFromUser(payload) {
  return apiBackofficeClient
    .post('/removeRoleFromUser', payload)
    .then(handleResponse)
    .catch(handleError)
}

async function setOrganizationRole(payload) {
  return apiBackofficeClient
    .put(`/setOrganizationRole/${payload.id}`,
      JSON.stringify(payload.newRoleName),
      getHeader())
    .then(handleResponse)
    .catch(handleError)
}
